<template>
  <a-drawer
    :title="title"
    :maskClosable="false"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :ok-disabled="disableSubmit"
    :visible="visible"
    style="height: 100%;overflow: auto;padding-bottom: 53px;">

    <template slot="title">
      <div style="width: 100%;">
        <span>{{ title }}</span>
        <span style="display:inline-block;width:calc(100% - 51px);padding-right:10px;text-align: right">
          <a-button @click="toggleScreen" icon="appstore" style="height:20px;width:20px;border:0px"></a-button>
        </span>
      </div>

    </template>

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">

        <a-form-model-item label="用户账号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="username">
          <a-input placeholder="请输入用户账号" v-model="model.username" :disabled="!!model.id" :maxLength="maxLength"/>
        </a-form-model-item>

        <template v-if="!model.id">
          <a-form-model-item label="登录密码" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="password" >
            <a-input-password type="password" placeholder="请输入登录密码" v-model="model.password" :maxLength="maxLength" :disabled="disableSubmit"/>
          </a-form-model-item>

          <a-form-model-item label="确认密码" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="confirmpassword" :disabled="disableSubmit">
            <a-input-password type="password" @blur="handleConfirmBlur" placeholder="请重新输入登录密码" v-model="model.confirmpassword" :maxLength="maxLength" :disabled="disableSubmit"/>
          </a-form-model-item>
        </template>

        <a-form-model-item label="用户姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="realname">
          <a-input placeholder="请输入用户姓名" v-model="model.realname" :maxLength="maxLength" :disabled="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item label="用户类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userType">
          <j-dict-select-tag type="radio" v-model="model.userType" :trigger-change="true" dictCode="user_type_emp" :disabled="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item label="工号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="workNo" v-if="!(model.userType==='nonemployee')">
          <a-input placeholder="请输入工号" v-model="model.workNo" :maxLength="maxLength" :disabled="disableSubmit"/>
        </a-form-model-item>
         <a-form-model-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="email">
          <a-input placeholder="请输入邮箱" v-model="model.email" :maxLength="50" :disabled="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item label="手机号码" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="phone">
          <a-input placeholder="请输入手机号码" v-model="model.phone" :maxLength="maxLength" :disabled="disableSubmit"/>
        </a-form-model-item>
        <a-form-model-item label="角色分配" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="!roleDisabled" v-if="roleLoading">
          <j-select-role-for-apllication v-model="model.selectedroles" :disabled="disableSubmit"
                                         :appId="apps?apps.join(','):''" :option="rolesOptions" :listUrl="roleListUrl"></j-select-role-for-apllication>

        </a-form-model-item>
        
        <a-col :span="24" style="height: 50px"></a-col>
      </a-form-model>
    </a-spin>


    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm title="确定放弃编辑？" @confirm="handleCancel" okText="确定" cancelText="取消">
        <a-button style="margin-right: .8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
  import moment from 'moment'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getAction,putAction,postAction } from '@/api/manage'
  import { addUser,editUser,queryUserRole,queryall } from '@/api/api'
  import { disabledAuthFilter } from "@/utils/authFilter"
  import { duplicateCheck } from '@/api/api'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSelectRoleForApplyCheck from '@/components/jeecgbiz/JSelectRoleForApplyCheck'
  import JSelectRoleForApllication from '@/components/jeecgbiz/JSelectRoleForApllication'

export default {
    name: "UserModal",
    components: {
      JDictSelectTag,
      JSelectRoleForApplyCheck,
      JSelectRoleForApllication,
    },
    data () {
      return {
        roleLoading:false,
        roleListUrl:'',
        apps:['1526828958439706625'],
        // uploadSource:"env",
        uploadSource:"prevent",
        maxLength: 20,
        appsOptions:[],
        departDisabled: false, //是否是我的部门调用该页面
        roleDisabled: false, //是否是角色维护调用该页面
        modalWidth:800,
        drawerWidth:700,
        modaltoggleFlag:true,
        confirmDirty: false,
        userId:"", //保存用户id
        disableSubmit:false,
        dateFormat:"YYYY-MM-DD",
        factoryOptions:[],
        areaOptions:[],
        buildingOptions:[],
        validatorRules:{
          username:[{required: true, message: '请输入用户账号!'},
                    {validator: this.validateUsername,}],
          password: [
            {required: true,message: '请输入密码!'},
            {validator: this.validateToNextPassword,trigger: 'change'}
          ],
          confirmpassword: [{required: true, message: '请重新输入登录密码!',},
                            { validator: this.compareToFirstPassword,}],
          realname:[{ required: true, message: '请输入用户名称!' }],
          userType:[{ required: true, message: '请选择用户类型!' }],
          phone: [{required: true, message: '请输入手机号!'}, {validator: this.validatePhone}],
          email: [{required: true, message: '请输入邮箱!'}, {validator: this.validateEmail}],
          roles:{},
          workNo:[ { required: true, message: '请输入工号' },
                  { validator: this.validateWorkNo }],
        },
        departIdShow:false,
        title:"操作",
        visible: false,
        model: {},
        employee:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        uploadLoading:false,
        confirmLoading: false,
        headers:{},
        url: {
          fileUpload: window._CONFIG['domianURL']+"/sys/common/upload",
          userWithDepart: "/sys/user/userDepartList", // 引入为指定用户查看部门信息需要的url
          userId:"/sys/user/generateUserId", // 引入生成添加用户情况下的url
          syncUserByUserName:"/act/process/extActProcess/doSyncUserByUserName",//同步用户到工作流
          queryTenantList: '/sys/tenant/queryList',
          checkUsernameAndWorkNoDuplicate: '/sys/user/checkUsernameAndWorkNoDuplicate',
        },
        tenantsOptions: [],
        rolesOptions:[],
        userDepartWithApplication:[],
        boo:false,
      }
    },
    created () {
      const token = Vue.ls.get(ACCESS_TOKEN);
      this.headers = {"X-Access-Token":token}
      this.initRoleList();
      this.initAppList();
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
      uploadAction:function () {
        return this.url.fileUpload;
      }
    },
    methods: {
      add () {
        this.refresh();
        this.edit({activitiSync:'1',userIdentity:1});
      },
      edit (record,appIds) {
        this.apps = appIds
        this.roleListUrl = '/sys/role/listByApplication?applicationIds='+(appIds?appIds.join(','):'');
        this.boo = false;
        this.employee = {};
        let that = this;
        this.initTenantList()
        that.visible = true;
        //根据屏幕宽度自适应抽屉宽度
        this.resetScreenSize();
        that.userId = record.id;
        that.model = Object.assign({},{selectedroles:'',selecteddeparts:'',selectedAppids:''}, record);
        that.selectedApps = [];
        

        if(record.hasOwnProperty("id")){
          that.getUserRoles(record.id);
          that.getUserApplications(record.id);
          this.getEmployeeData(record.id);
        }else {
          this.roleLoading = true;
        }
        console.log('that.model=',that.model)
      },
      isDisabledAuth(code){
        return disabledAuthFilter(code);
      },
      //窗口最大化切换
      toggleScreen(){
        if(this.modaltoggleFlag){
          this.modalWidth = window.innerWidth;
        }else{
          this.modalWidth = 800;
        }
        this.modaltoggleFlag = !this.modaltoggleFlag;
      },
      // 根据屏幕变化,设置抽屉尺寸
      resetScreenSize(){
        let screenWidth = document.body.clientWidth;
        if(screenWidth < 500){
          this.drawerWidth = screenWidth;
        }else{
          this.drawerWidth = 700;
        }
      },
      //初始化租户字典
      initTenantList(){
        getAction(this.url.queryTenantList).then(res=>{
          if(res.success){
            this.tenantsOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.name, value: item.id+""}
              return c;
            })
            console.log('this.tenantsOptions: ',this.tenantsOptions)
          }
        })
      },
      //初始化角色字典
      initRoleList(){
        queryall().then((res)=>{
          if(res.success){
            this.rolesOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.roleName, value:item.id}
              return c;
            })
            console.log('this.rolesOptions: ',this.rolesOptions)
          }
        });
      },
      getUserRoles(userid){
        queryUserRole({userid:userid}).then((res)=>{
          if(res.success){
            this.model.selectedroles = res.result.join(",");
            this.roleLoading = true;
            console.log('that.model.selectedroles=',this.model.selectedroles)
          }else{
            this.roleLoading = true;
          }
        });
      },
      getUserDeparts(userid,applicationIds,applicaitonList){
        this.userDepartWithApplication = [];
        let that = this;
        getAction(that.url.userWithDepart,{userId:userid}).then((res)=>{
          if(res.success){
            applicationIds.forEach(id=>{
              let map={};
              let selectDepart=[]
              let selectDepartNames = "";
              for (let i = 0; i < res.result.length; i++) {
                let value = res.result[i];
                if(value.applicationId == id){
                  selectDepart.push(value.key);
                  if(selectDepartNames == ""){
                    selectDepartNames = value.title;
                  }else{
                    selectDepartNames = selectDepartNames+"\u00A0 |\u00A0 "+value.title;
                  }
                }
              }
              map.applicationId = id;
              map.selectedDeparts = selectDepart;
              map.selectedDepartNames = selectDepartNames;
              this.userDepartWithApplication.push(map);
              if(applicaitonList.length>0){
                applicaitonList.forEach(item=>{
                  if(item.id == id)item.selectedDepartNames = selectDepartNames
                })
              }
              this.selectedApps = applicaitonList;
            })

          }
        })
      },
      refresh () {
        this.userId=""
        this.departIdShow=false;
      },
      close () {
        // if(this.roleDisabled)this.$emit('cleanUserName');
        this.$emit('close');
        this.roleLoading = false;
        this.visible = false;
        this.disableSubmit = false;
        this.departIdShow=false;
        this.$refs.form.resetFields();
      },
      moment,
      handleSubmit () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            // that.confirmLoading = true;
            //如果是上级择传入departIds,否则为空
            if(this.model.userIdentity!==2){
              this.model.departIds="";
            }
            let obj;
            if(!this.model.id){
              this.model.id = this.userId;
              obj=addUser(this.model);
            }else{
              obj=editUser(this.model);
            }
            obj.then((res)=>{
              if(res.success){
                let param = this.employee;
                param.id = res.result.id;
                putAction("/sys/employee/editEmployee",param).then((data)=>{
                  if(data.success){
                    if(this.userId){
                      let map = {};
                      map.data=this.userDepartWithApplication
                      map.userId = this.userId
                      putAction("/sys/UserDepart/addList", map).then((res)=> {
                        if (res.success) {
                          that.$message.success(res.message);
                          that.$emit('ok');
                          if(that.roleDisabled)that.$emit('cleanUserName');
                        }
                      })
                    }else{
                      that.$message.success(res.message);
                      that.$emit('ok');
                      if(that.roleDisabled)that.$emit('cleanUserName');
                    }
                  }
                })
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateToNextPassword (rule, value, callback) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('不能输入汉字!'));
        } else if(!(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/.test(value))){
          callback(new Error('密码由8位数字、大小写字母和特殊符号组成!'));
        } else {
          const confirmpassword=this.model.confirmpassword;
          if (value && confirmpassword && value !== confirmpassword) {
            callback('两次输入的密码不一样！');
          }
          if (value && this.confirmDirty) {
            this.$refs.form.validateField(['confirmpassword']);
          }
          callback();
        }
      },
      compareToFirstPassword (rule, value, callback) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('不能输入汉字!'));
        } else {
          if (value && value !== this.model.password) {
            callback('两次输入的密码不一样！');
          } else {
            callback()
          }
        }
      },
      validatePhone(rule, value, callback){
        let that = this;
        if(!value){
          callback()
        }else{
         // if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)){
            let params = {
              id: this.userId,
              phone: value
            };
            getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
              if (res.success) {
                callback()
              } else {
                callback("手机号已存在!")
              }
            })
        }
      },
      validateEmail(rule, value, callback){
        let that = this;
        if(!value){
          callback()
        }else{
          if(new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)){
            //2022/3/10 不校验邮箱唯一性，公司内部存在共用邮箱的情况
            callback();
          }else{
            callback("请输入正确格式的邮箱!")
          }
        }
      },
      validateUsername(rule, value, callback){
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('不能输入汉字!'));
        } else {
          let that = this;
          let params = {
            id: this.userId,
            username: value
          };
          getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
            if (res.success) {
              callback()
            } else {
              callback("用户名已存在!")
            }
          })
        }
      },
      validateWorkNo(rule, value, callback){
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('不能输入汉字!'));
        } else {
          let that = this;
          let params = {
            id: this.userId,
            workNo: value
          };
          getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
            if (res.success) {
              callback()
            } else {
              callback("工号已存在!")
            }
          })
        }
      },
      handleConfirmBlur(e) {
        const value = e.target.value;
        this.confirmDirty = this.confirmDirty || !!value
      },
      beforeUpload: function(file){
        var fileType = file.type;
        if(fileType.indexOf('image')<0){
          this.$message.warning('请上传图片');
          return false;
        }
        //TODO 验证文件大小
      },
      identityChange(e){
        if(e.target.value===1){
            this.departIdShow=false;
        }else{
            this.departIdShow=true;
        }
      },

      //初始化应用list
      initAppList(){
        getAction("/sys/portal/sysPortalOrg/getAllApps").then((res)=>{
          if(res.success){
            this.appsOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationName, value:item.id}
              return c;
            })
            console.log('this.appsOptions: ',this.appsOptions)
          }
        })
      },
      getUserApplications(userId){
        let params = {
          id: userId,
        };
        getAction("/sys/user/getUserApplications", params).then((res)=>{
          if (res.success) {
            let list = res.result;
            let ids = "";
            if(list){
              list.forEach(item=>{
                if(ids == ""){
                  ids = item.id;
                }else{
                  ids = ids+","+item.id;
                }
              })
            }
            // this.selectedApps = list;
            this.model.selectedAppids = ids;
            console.log('that.model.selectedApps=',this.selectedApps)
            this.getUserDeparts(userId,ids.split(","),list);
          }
        })
      },
      getEmployeeData(userId){
        getAction("/sys/employee/queryById",{id:userId}).then((res)=>{
          if(res.success){
            this.employee = res.result;
          }
        })
      },

    }
  }
</script>

<style scoped>
  .components-input-demo-presuffix .anticon-close-circle {
    cursor: pointer;
    color: #ccc;
    transition: color 0.3s;
    font-size: 12px;
  }
  .components-input-demo-presuffix .anticon-close-circle:hover {
    color: #f5222d;
  }
  .components-input-demo-presuffix .anticon-close-circle:active {
    color: #666;
  }
  .avatar-uploader > .ant-upload {
    width:104px;
    height:104px;
  }
  .ant-upload-select-picture-card i {
    font-size: 49px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .ant-table-tbody .ant-table-row td{
    padding-top:10px;
    padding-bottom:10px;
  }

  .drawer-bootom-button {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>